
export const FetchServiceSymbol = Symbol.for('FetchService')
export const FetchErrorNotificationServiceSymbol = Symbol.for('FetchErrorNotificationService')
